import React from 'react';
import { BlockItem } from '../utils/types';
import BlockInfo from './BlockInfo';

interface BlockItemProps {
    item: BlockItem;
}

const BlockItem = ({ item }) => (
    <div className="filters-block-item unlink">

        {item.MediaType === "Image" &&
            <a className="unlink" href={item.LinkUrl} target="_blank">
                <div className="media-item-container">
                    <img src={item.MediaUrl} alt={item.Title} className="" />
                </div>
            </a>

        }
        {(item.MediaType === "umbracoMediaVideo" || item.MediaType === "externalVideo") && (
            <a className="unlink" href={item.LinkUrl} target="_blank">
                <div className="media-item-container">
                    <img src={item.FallBackImageUrl} alt={item.Title} className="" />
                    <span className="media-item-play" data-video-play>
                        <span className="media-item-play-btn"></span>
                    </span>
                </div>
            </a>
        )}

        {item.MediaType === "File" ?
            <a href={item.LinkUrl} target="_blank" className="filter-block-card unlink">
                <div className="filter-block-card-inner stack-md">
                    <BlockInfo item={item} />
                </div>
            </a>
            :
            <BlockInfo item={item} />
        }
    </div>
);

export default BlockItem;